var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#E3E3E3",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005082",
    fillRule: "nonzero",
    d: "M8.17900063,10.5015813 L8.17900063,10.5015813 C8.37634409,10.3042378 8.37634409,9.98545225 8.17900063,9.78810879 L6.22074636,7.82479443 L8.18406072,5.86148008 C8.38140417,5.66413662 8.38140417,5.34535104 8.18406072,5.14800759 L8.18406072,5.14800759 C7.98671727,4.95066414 7.66793169,4.95066414 7.47058824,5.14800759 L5.14800759,7.47058824 C4.95066414,7.66793169 4.95066414,7.98671727 5.14800759,8.18406072 L7.47058824,10.5066414 C7.6628716,10.6989247 7.98165718,10.6989247 8.17900063,10.5015813 Z",
    transform: "matrix(-1 0 0 1 13.332 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005082",
    fillRule: "nonzero",
    d: "M11.513599,10.5015813 L11.513599,10.5015813 C11.7109424,10.3042378 11.7109424,9.98545225 11.513599,9.78810879 L9.55534472,7.82479443 L11.5186591,5.86148008 C11.7160025,5.66413662 11.7160025,5.34535104 11.5186591,5.14800759 L11.5186591,5.14800759 C11.3213156,4.95066414 11.00253,4.95066414 10.8051866,5.14800759 L8.48260595,7.47058824 C8.28526249,7.66793169 8.28526249,7.98671727 8.48260595,8.18406072 L10.8051866,10.5066414 C10.99747,10.6989247 11.3162555,10.6989247 11.513599,10.5015813 Z",
    transform: "matrix(-1 0 0 1 20.001 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon_arrow.2461231b6712d3b4d25729d1b051bc16.svg";
export { ForwardRef as ReactComponent };